"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id", "checked", "disabled", "name", "required", "value"];
const vue_3 = require("vue");
const use_input_validation_1 = __importDefault(require("../../composables/use-input-validation"));
const SvgIcon_vue_1 = __importDefault(require("../SvgIcon/SvgIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedRadio',
    props: {
        checked: { type: Boolean },
        dataTestName: { default: "" },
        disabled: { type: Boolean },
        disableErrorDesign: { type: Boolean },
        id: {},
        modelValue: {},
        name: {},
        radioValue: {},
        required: { type: Boolean },
        srOnlyInput: { type: Boolean },
        chip: { type: Boolean },
        iconLeft: { type: Boolean },
        iconName: {}
    },
    emits: ["update:modelValue", "change", "input"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputRef = (0, vue_3.useTemplateRef)("inputRef");
        const forcedErrorMessage = (0, vue_3.inject)("forcedErrorMessage", undefined);
        const { errorMessage, handleInput, isValidationVisible } = (0, use_input_validation_1.default)(inputRef, props.name || "", undefined, forcedErrorMessage);
        const hasSlot = (0, vue_3.computed)(() => !!(0, vue_3.useSlots)().default);
        const checkedRadio = (0, vue_3.inject)("checkedRadio", (0, vue_3.ref)(null));
        const isChecked = (0, vue_3.computed)(() => props.checked || // Forced state
            props.radioValue === props.modelValue || // Model state through prop directly
            checkedRadio.value === props.radioValue // Model state through SharedRadioGroup
        );
        (0, vue_3.watch)(() => checkedRadio.value, () => {
            if (checkedRadio.value !== props.radioValue)
                handleInput();
        });
        const isRadioGroupChip = (0, vue_3.inject)("isRadioGroupChip", false);
        const isChip = (0, vue_3.computed)(() => isRadioGroupChip || props.chip);
        const radioGroupName = (0, vue_3.inject)("radioGroupName");
        const isRadioGroupRequired = (0, vue_3.inject)("isRadioGroupRequired", false);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const updateCheckedRadio = (0, vue_3.inject)("updateCheckedRadio", (_value) => { });
        props.checked && updateCheckedRadio(props.radioValue);
        (0, vue_3.watch)(() => props.modelValue, (newValue) => {
            updateCheckedRadio(newValue);
            handleInput();
        });
        const handleChange = (event) => {
            const val = event.target.value;
            updateCheckedRadio(val);
            emit("update:modelValue", val);
            emit("change", event);
            emit("input", event);
            handleInput();
        };
        const updateInputValidityState = (0, vue_3.inject)("updateInputValidityState", 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_errorMessage, _isValidationVisible) => null);
        const updateInputValidityStateForSelectionCard = (0, vue_3.inject)("updateInputValidityStateForSelectionCard", 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_isValidationVisible) => null);
        (0, vue_3.watchEffect)(() => {
            updateInputValidityState(errorMessage.value, isValidationVisible.value);
            updateInputValidityStateForSelectionCard(isValidationVisible.value);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                class: (0, vue_2.normalizeClass)(["tw relative inline-flex select-none text-sm", [
                        _ctx.disabled ? 'cursor-not-allowed text-gray-50' : 'cursor-pointer',
                        {
                            'h-9 items-center justify-center whitespace-nowrap rounded-full border bg-white px-4 has-[input:active]:bg-gray-60': isChip.value,
                            'supportsHover:hover:bg-gray-40': isChip.value && !_ctx.disabled,
                            'border-gray-40 bg-gray-30 text-gray-50': isChip.value && _ctx.disabled,
                            'border-gray-40': isChip.value && !isChecked.value && !(0, vue_2.unref)(isValidationVisible),
                            'shadow-inset': isChip.value && !_ctx.disabled && isChecked.value,
                            'border-error shadow-inset shadow-error': isChip.value && (0, vue_2.unref)(isValidationVisible) && !_ctx.disabled && !_ctx.disableErrorDesign,
                            'text-error': !isChip.value && (0, vue_2.unref)(isValidationVisible) && !_ctx.disableErrorDesign,
                        },
                    ]]),
                style: { "-webkit-tap-highlight-color": "transparent" }
            }, [
                (0, vue_2.createElementVNode)("input", (0, vue_2.normalizeProps)({
                    id: _ctx.id,
                    ref_key: "inputRef",
                    ref: inputRef,
                    type: "radio",
                    class: ["appearance-none",
                        _ctx.srOnlyInput
                            ? 'sr-only'
                            : {
                                'w-0': isChip.value,
                                'relative mt-0.5 size-4 shrink-0 cursor-pointer rounded-full border bg-white text-base outline-none before:absolute before:-left-[5px] before:-top-[5px] before:size-[calc(100%+10px)] before:rounded-full after:absolute after:left-1/2 after:top-1/2 after:size-2 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full focus-visible:before:border-2 focus-visible:before:border-black-primary disabled:cursor-not-allowed': !isChip.value,
                                'border-gray-50 checked:after:bg-gray-50': !isChip.value && _ctx.disabled,
                                'checked:after:bg-black-primary active:before:border-2 active:before:border-black-primary': !isChip.value && !_ctx.disabled,
                                'mr-2': !isChip.value && hasSlot.value,
                                'border-error checked:after:bg-error active:before:border-error': !isChip.value && (0, vue_2.unref)(isValidationVisible) && !_ctx.disableErrorDesign,
                                'border-black-primary': !isChip.value && !(0, vue_2.unref)(isValidationVisible),
                            }
                    ],
                    checked: isChecked.value,
                    disabled: _ctx.disabled,
                    name: (0, vue_2.unref)(radioGroupName) || _ctx.name,
                    required: ((0, vue_2.unref)(isRadioGroupRequired) && !_ctx.disabled) || _ctx.required,
                    value: _ctx.radioValue,
                    [_ctx.dataTestName || ""]: '',
                    onChange: handleChange
                }), null, 16, _hoisted_1),
                (!_ctx.iconLeft)
                    ? (0, vue_2.renderSlot)(_ctx.$slots, "default", { key: 0 })
                    : (0, vue_2.createCommentVNode)("", true),
                (_ctx.iconName && isChip.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                        key: 1,
                        "icon-name": _ctx.iconName,
                        class: (0, vue_2.normalizeClass)(["size-5 shrink-0", _ctx.iconLeft ? 'mr-2' : 'ml-2'])
                    }, null, 8, ["icon-name", "class"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (_ctx.iconLeft)
                    ? (0, vue_2.renderSlot)(_ctx.$slots, "default", { key: 2 })
                    : (0, vue_2.createCommentVNode)("", true)
            ], 2));
        };
    }
});
